import Slick from 'vue-slick';
import { trackProductClicks } from '../vendors/searchspring';

export default {
    components: {
        Slick
    },
    props: {
        product: {
            type: Object,
            required: true
        },
        parsedFileUrl: {
            type: String,
            default: 'false'
        },
        previewImageToggles: {
            type: Object
        }
    },

    data() {
        return {
            url: null,
            fileUrl: this.parsedFileUrl !== 'false' ? this.parsedFileUrl : false,
            currentTitle: this.product.title,
            currentImage: 0
        }
    },

    computed: {
        isSale() {
            return this.product?.compare_at_price > this.product.price;
        },

        productImage() {
            if (!this.product.images?.length) return this.product.product_image;
            return this.product.images[0];
        },

        isPriceRanging() {
            return this.product.variants_max_price > this.product.variants_min_price
        }
    },

    created() {
        if (!this.product.url) {
            this.url = `/products/${this.product.handle}`;
        }
    },

    mounted() {
        if (this.$refs.productImages) {
            this.$refs.productImages[0]?.$on('afterChange', (event, slick, currentSlide, nextSlide) => {
                this.currentImage = currentSlide
            })
        }
    },

    methods: {
        togglePreviewImageToggles(handle) {
            for(const previewImageToggle in this.previewImageToggles) {
                if(previewImageToggle !== handle) {
                    this.previewImageToggles[previewImageToggle] = false;
                }
            }

            if(handle in this.previewImageToggles) {
                this.previewImageToggles[handle] = !this.previewImageToggles[handle]
                
                this.$nextTick(() => {
                    for (const sibling of this.product.siblings) {
                        if (this.previewImageToggles[`${this.product.handle}_${sibling.handle}`]) {
                            this.currentTitle = sibling.title;
                        }
                    }
                })
            }
            this.$el.classList.add('hovering-sibling')
        },

        closeAllPreviewImages() {
            for (let previewImage in this.previewImageToggles) {
                this.previewImageToggles[previewImage] = false;
            }

            this.currentTitle = this.product.title;
            this.$el.classList.remove('hovering-sibling')
        },
        handleProductItemClick(event) {
            if (!event.target.classList.contains('slick-arrow')) {
                // Searchspring tracking -
                // https://docs.searchspring.com/reference/intellisuggest_tracking#product-click-result-click-tracking 
                if (this.product.intellisuggestData && this.product.intellisuggestSignature) {
                    trackProductClicks(this.product.intellisuggestData, this.product.intellisuggestSignature);
                }

                window.location.href = event.target.closest('a').href ?? '#'
            }
        }
    }
}